import { InvoiceExtractStatus } from '../../features/shared/models/invoice-extract.types';

export interface InvoiceStatusDefinition {
  /** Query enum value accepted by the `statusFatura` filter param. */
  enumValue: InvoiceExtractStatus;
  /** Backend `codigo` values (from GET /fatura) that belong to this status. */
  codes: readonly string[];
  badgeClass: string;
  labelKey: string;
}

/**
 * Single source of truth tying the backend numeric `codigo` (item status) to the
 * `InvoiceExtractStatus` filter enum, the badge CSS class, and the i18n label.
 * Adding/renaming a status only requires touching this list.
 */
export const INVOICE_STATUS_DEFINITIONS: readonly InvoiceStatusDefinition[] = [
  {
    enumValue: 'A_INICIAR_AUDITORIA',
    codes: ['-1'],
    badgeClass: 'invoice-status-badge--start-audit',
    labelKey: 'invoice_extract.status.start_audit',
  },
  {
    enumValue: 'EM_AUDITORIA',
    codes: ['1', '2', '10'],
    badgeClass: 'invoice-status-badge--in-audit',
    labelKey: 'invoice_extract.status.in_audit',
  },
  {
    enumValue: 'APROVADA_PARA_PAGAMENTO',
    codes: ['3'],
    badgeClass: 'invoice-status-badge--approved',
    labelKey: 'invoice_extract.status.approved_for_payment',
  },
  {
    enumValue: 'FATURA_PAGA',
    codes: ['20'],
    badgeClass: 'invoice-status-badge--paid',
    labelKey: 'invoice_extract.status.invoice_paid',
  },
  {
    enumValue: 'PENDENCIA_TRANSPORTADOR',
    codes: ['30'],
    badgeClass: 'invoice-status-badge--waiting-carrier',
    labelKey: 'invoice_extract.status.waiting_carrier',
  },
  {
    enumValue: 'OUTROS',
    codes: [],
    badgeClass: 'invoice-status-badge--default',
    labelKey: 'invoice_extract.status.others',
  },
];

/**
 * Maps the invoice `codigo` field (returned by GET /fatura, not the human-readable
 * `status` text) to the CSS badge class used by both the invoice-extract table and
 * the invoice details sidebar.
 */
export function getInvoiceStatusBadgeClass(codigo: string): string {
  const definition = INVOICE_STATUS_DEFINITIONS.find((d) => d.codes.includes(codigo));
  return `invoice-status-badge ${definition?.badgeClass ?? 'invoice-status-badge--default'}`;
}
